module.exports = __webpack_public_path__ + "img/character-platform.00e55b63.png";